// --- SHIMS per Enterprise -> Athens ---
// 1) initLazyScript: in Enterprise inizializza lazy; qui lo eseguiamo subito
window.initLazyScript = window.initLazyScript || function (_el, cb) {
  if (typeof cb === 'function') cb();
};

// 2) debounce minimale (leading=false)
window.debounce = window.debounce || function (fn, wait) {
  let t;
  return function (...args) {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

// 3) theme.device.hasTouch
window.theme = window.theme || {};
theme.device = theme.device || {
  hasTouch:
    ('ontouchstart' in window) ||
    (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints && navigator.msMaxTouchPoints > 0)
};
